<p-sidebar [visible]="true"
           [position]="'right'"
           [baseZIndex]="10000"
           [modal]="true"
           (onHide)="handleSideBarHide()"
           [style]="{width:'700px'}">

    <ng-template pTemplate="header">{{restaurantId ? 'Edit Restaurant' : 'Add Restaurant'}}</ng-template>

    <p-scrollPanel [style]="{width:'100%', height: 'calc(100vh - 220px)'}"
                   [styleClass]="'app-scrollpanel'">
        <div style="padding: 10px">
            <div class="field">
                <div>Image</div>

                <div style="margin-right: 10px">
                    <a href="{{restaurant.ImageUrl}}" target="_blank">
                        <img style="max-width: 260px" src="{{restaurant.ImageUrl}}" />
                    </a>
                </div>
                <div>
                    <input id="idImgInput"
                           type="file"
                           accept="image/*"
                           style="display: none"
                           (change)="handleImageChange($event)" />

                    <button pButton
                            type="button"
                            label="Upload"
                            class="edit-rest-btn"
                            icon="pi pi-upload"
                            (click)="handleUploadClick()"></button>
                </div>
            </div>

            <div class="field">
                <div>Name</div>
                <input pInputText class="edit-rest-field" [(ngModel)]="restaurant.Name" />
            </div>
        </div>
    </p-scrollPanel>

    <hr style="margin-left: -1rem; margin-right: -1rem;" />

    <div class="flex-row" style="padding-left: 10px; padding-right: 10px">
        <div>
            <button pButton
                    type="button"
                    label="Cancel"
                    class="p-button-danger"
                    (click)="handleSideBarHide()"></button>
        </div>

        <div class="filler"></div>

        <div>
            <button pButton
                    type="button"
                    label="{{restaurantId ? 'Save' : 'Create'}}"
                    class="edit-rest-btn"
                    (click)="handleSaveClick()"></button>
        </div>
    </div>
</p-sidebar>

<p-toast position="top-right"></p-toast>
